export default __webpack_public_path__ + "static/media/982.6391447e.gif";